/**
 * Parc Fermé — Fast Simon autocomplete shadow-DOM skin.
 *
 * The Fast Simon "no-code" header autocomplete widget renders its overlay
 * inside an OPEN shadow root (light-DOM host: div.fast-ac-container /
 * .mobile-fast-ac-container). Plain <link>/<style> tags in the light DOM
 * (assets/*.css) cannot cross that boundary, so this file injects a single
 * <style> element directly into each host's shadowRoot once it appears.
 *
 * This is CSS-only in effect: it never touches FS's event handlers, search
 * logic, or DOM structure — it only adds a stylesheet. Delivery mechanism is
 * JS purely because that's the only way to reach inside an open shadow root.
 */
(function () {
  try {
    var STYLE_ID = 'pf-fastsimon-shadow-style';

    var CSS = [
      /* Panel shell */
      '[id^="fast-autocomplete"], .autocomplete-inner {',
      '  background: #131318 !important;',
      '  color: #f5f5f3 !important;',
      '}',
      '[id^="fast-autocomplete"] {',
      '  border: 1px solid #26262e !important;',
      '  box-shadow: 0 12px 32px rgba(0,0,0,0.55) !important;',
      '}',
      '.autocomplete-inner {',
      '  scrollbar-width: thin;',
      '  scrollbar-color: #26262e #131318;',
      '}',
      '.autocomplete-inner::-webkit-scrollbar { width: 8px; height: 8px; }',
      '.autocomplete-inner::-webkit-scrollbar-track { background: #131318; }',
      '.autocomplete-inner::-webkit-scrollbar-thumb { background: #26262e; border-radius: 4px; }',
      '.autocomplete-inner::-webkit-scrollbar-thumb:hover { background: #86868f; }',

      /* Section headings: Recent Searches / Popular Searches / Collections */
      '.fs-autocomplete-header, .header.fs-autocomplete-header {',
      '  font-family: "IBM Plex Mono", monospace !important;',
      '  font-size: 12px !important;',
      '  line-height: 1.4 !important;',
      '  text-transform: uppercase !important;',
      '  letter-spacing: 0.14em !important;',
      '  color: #86868f !important;',
      '  background: transparent !important;',
      '}',
      '.fs-autocomplete-header svg, .fs-autocomplete-header path {',
      '  fill: #86868f !important;',
      '  stroke: #86868f !important;',
      '}',

      /* Recent / popular search terms rendered as bordered mono pill chips */
      '.fast-ac-item.line-item {',
      '  display: inline-flex !important;',
      '  align-items: center !important;',
      '  border: 1px solid #26262e !important;',
      '  border-radius: 999px !important;',
      '  background: #08080a !important;',
      '  color: #f5f5f3 !important;',
      '  font-family: "IBM Plex Mono", monospace !important;',
      '  font-size: 12px !important;',
      '  letter-spacing: 0.04em !important;',
      '  padding: 6px 14px !important;',
      '  margin: 4px !important;',
      '  transition: border-color 0.15s ease, color 0.15s ease, transform 0.15s ease !important;',
      '}',
      '.fast-ac-item.line-item a, .fast-ac-item.line-item span {',
      '  color: inherit !important;',
      '  font-size: inherit !important;',
      '  font-family: inherit !important;',
      '}',
      '.fast-ac-item.line-item:hover, .fast-ac-item.line-item:focus-within {',
      '  border-color: #e10600 !important;',
      '  color: #e10600 !important;',
      '  transform: translateY(-2px) !important;',
      '}',

      /* Collections list links */
      '.fs-category-list a {',
      '  color: #f5f5f3 !important;',
      '  font-family: "IBM Plex Mono", monospace !important;',
      '  font-size: 12.5px !important;',
      '  text-decoration: none !important;',
      '  transition: color 0.15s ease !important;',
      '}',
      '.fs-category-list a:hover, .fs-category-list a:focus-visible {',
      '  color: #e10600 !important;',
      '}',

      /* Product cards in the horizontal result rail */
      '.fast-ac-item.fs-product {',
      '  background: transparent !important;',
      '  border-radius: 4px !important;',
      '  transition: transform 0.18s ease, border-color 0.18s ease !important;',
      '}',
      '.fast-ac-item.fs-product:hover, .fast-ac-item.fs-product:focus-visible {',
      '  transform: translateY(-3px) !important;',
      '}',
      '.fast-ac-item.fs-product:focus-visible {',
      '  outline: 2px solid #ffd100 !important;',
      '  outline-offset: 2px !important;',
      '}',

      /* Product image wrapper — leave the <img> itself untouched */
      '.fs-product-image {',
      '  background: #101014 !important;',
      '  border: 1px solid #26262e !important;',
      '  border-radius: 4px !important;',
      '  transition: border-color 0.18s ease !important;',
      '}',
      '.fast-ac-item.fs-product:hover .fs-product-image {',
      '  border-color: #86868f !important;',
      '}',

      /* Product title / vendor */
      '.fs-product-title, .fs-product-title .label {',
      '  color: #f5f5f3 !important;',
      '  font-size: 12.5px !important;',
      '  line-height: 1.4 !important;',
      '  font-family: "IBM Plex Mono", monospace !important;',
      '}',
      '.fs-product-vendor, .fs-product-vendor .label {',
      '  color: #9b9ba4 !important;',
      '  font-size: 12px !important;',
      '  font-family: "IBM Plex Mono", monospace !important;',
      '  text-transform: uppercase !important;',
      '  letter-spacing: 0.08em !important;',
      '}',

      /* Prices: mono white default, gold sale price + grey strikethrough compare-at */
      '.fs-product-price-wrapper {',
      '  font-family: "IBM Plex Mono", monospace !important;',
      '  font-size: 12.5px !important;',
      '}',
      '.fs-price.actual-price {',
      '  color: #f5f5f3 !important;',
      '}',
      '.fs-product-price-wrapper.compareExist .fs-price.actual-price {',
      '  color: #ffd100 !important;',
      '  font-weight: 600 !important;',
      '}',
      '.fs-price.compare {',
      '  color: #86868f !important;',
      '  text-decoration: line-through !important;',
      '}',

      /* Defensive: any stray input rendered inside the shadow root */
      '[id^="fast-autocomplete"] input {',
      '  background: #0e0e12 !important;',
      '  color: #f5f5f3 !important;',
      '  border: 1px solid #26262e !important;',
      '  font-size: 12.5px !important;',
      '}',
      '[id^="fast-autocomplete"] input:focus-visible {',
      '  outline: 2px solid #ffd100 !important;',
      '  outline-offset: 1px !important;',
      '}',

      /* Generic focus-visible safety net for anything else in the panel */
      '[id^="fast-autocomplete"] a:focus-visible, [id^="fast-autocomplete"] button:focus-visible {',
      '  outline: 2px solid #ffd100 !important;',
      '  outline-offset: 2px !important;',
      '}'
    ].join('\n');

    function injectInto(shadowRoot) {
      if (!shadowRoot || shadowRoot.getElementById(STYLE_ID)) return false;
      var style = document.createElement('style');
      style.id = STYLE_ID;
      style.setAttribute('data-pf-injected', '1');
      style.textContent = CSS;
      shadowRoot.appendChild(style);
      return true;
    }

    function tryHost(host) {
      if (!host || host.getAttribute('data-pf-shadow-skinned') === '1') return;
      var sr = host.shadowRoot;
      if (sr && injectInto(sr)) {
        host.setAttribute('data-pf-shadow-skinned', '1');
        try { console.debug('[pf-fastsimon-shadow] injected dark theme into', host.className); } catch (e) {}
      }
    }

    function scan(root) {
      try {
        var hosts = root.querySelectorAll('div.fast-ac-container, .mobile-fast-ac-container');
        hosts.forEach(tryHost);
      } catch (e) {}
    }

    scan(document);

    var observer = new MutationObserver(function (mutations) {
      try {
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          if (m.addedNodes && m.addedNodes.length) {
            m.addedNodes.forEach(function (node) {
              if (node.nodeType !== 1) return;
              if (node.matches && node.matches('div.fast-ac-container, .mobile-fast-ac-container')) {
                tryHost(node);
              }
              if (node.querySelectorAll) {
                scan(node);
              }
            });
          }
        }
        scan(document);
      } catch (e) {}
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {
    // Never throw — this is a cosmetic enhancement only.
  }
})();